import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import Loading from "../Loading";
import PostItem from "./Item";

function Posts() {
    const dispatch = useDispatch();
    const { blogs, isLoading, isError, error } = useSelector(
        (state) => state.blogs
    );
    const { sorting, filtering } = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchBlogs({ sorting, filtering }));
    }, [dispatch, sorting, filtering]);

    if (isLoading || !blogs) {
        return <Loading />;
    }

    if (isError) {
        return <h1 className="text-xl">{error}!</h1>;
    }

    return (
        <main className="post-container" id="lws-postContainer">
            {blogs.map((blog) => (
                <PostItem key={blog.id} blog={blog} />
            ))}
        </main>
    );
}

export default Posts;
